
export const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};
